import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HOC } from 'formsy-react';
import SpecificTimeDetailsWeekly from './SpecificTimeDetailsWeekly';
import DetailsMonthly from '../shared/DetailsMonthly';

class SpecificTimeDetails extends Component {
  componentWillReceiveProps = newProps => {
    const { recurrenceType, setValue } = this.props;
    if (recurrenceType !== newProps.recurrenceType) {
      setValue(undefined);
    }
  };
  render() {
    switch (this.props.recurrenceType) {
      default:
      case 'Daily': {
        return null;
      }
      case 'Weekly': {
        return <SpecificTimeDetailsWeekly {...this.props} />;
      }
      case 'Monthly': {
        return <DetailsMonthly {...this.props} />;
      }
    }
  }
}

SpecificTimeDetails.defaultProps = {
  disabled: false,
};

SpecificTimeDetails.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  // These are required be the dependant components
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  /* eslint-enable */
  recurrenceType: PropTypes.string.isRequired,
};

export default HOC(SpecificTimeDetails);
